module.exports = __webpack_public_path__ + "static/water_nubian2-f6ed438048416b02376c5d5ce144068b.jpg";